import React from 'react'
import { EventGQL } from '../../../../Api'
import { Btn } from '../../../../Components/Buttons/Btn'
import { Head2 } from '../../../../Components/Typography/Text.styles'
import { NoDateCalloutCon } from './weekStyles'
import { getMarketPresale, logEvent } from '../../../../Utils'
import { Lk } from '../../../../Components/Links/Lk'

type LocationParams = {
  event: EventGQL
  page: string
}

export const NoDateCallout: React.FC<LocationParams> = ({ event, page }) => {
  let analytics = {
    event: 'presale_click',
    params: {
      game: event.slugname,
      section: `${page}_presale_callout`,
    },
  }
  const presaleUrl =
    event.waitlistUrl ||
    getMarketPresale(event.location)

  const handlePopupClick = () => {
    console.log('Waitlist Clicked')
    logEvent(analytics.event, analytics.params)
  }

  return (
    <>
      <NoDateCalloutCon>
        <Head2 justify="center">
          Matchups and times will be released later. Sign up for the{' '}
          {event.location && event.location.split(', ')[0]} ticket presale.
        </Head2>
        <Lk link={presaleUrl} target="_blank" rel="noreferrer" alt="Sign up for the presale">
          <Btn handleClick={handlePopupClick} btnStyle="primary">
            Sign Up
          </Btn>
        </Lk>
      </NoDateCalloutCon>
    </>
  )
}
